// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3930) return "static/chunks/164f4fb6-6e37caf951ded019.js";
	if (chunkId === 5007) return "static/chunks/5007-89d414589a7103a1.js";
	if (chunkId === 2531) return "static/chunks/2531-67697fca00f388f4.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"501":"bc98253f","3524":"2170a4aa","4316":"ad2866b8"}[chunkId] || chunkId) + "." + {"501":"e5fdcd237b390321","2112":"cd85fc5d6fb44c67","3239":"9e6e90e67018d18c","3524":"d83fac6bb29a7e65","3756":"e3dcfa47bb7b359c","3886":"b5c1e6a2f62caaee","4316":"da7517a88118b074","7604":"867d8350b0a9bae6","8436":"39669319b9f31b0a","9839":"a0d948d69591340d"}[chunkId] + ".js";
};